import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './tooltip.module.scss';
import { Link } from 'react-router-dom';
class Tooltip extends Component {
  constructor() {
    super();
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    this.props.mouseIsIn(true);
  }

  handleMouseLeave() {
    this.props.mouseIsIn(false);
  }

  render() {
    const { position, isVisible, content, link } = this.props;
    return (
      <div
        style={{
          left: `${position}px`,
          display: isVisible ? 'block' : 'none',
        }}
        className={styles.tooltipWrapper}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className={styles.tooltip}>
          <div className={styles.tooltipInner}>
            <div className={styles.tooltipInnerTop}>
              <p className={styles.tooltipContentText}>{content}</p>
            </div>
            <Link className={styles.tooltipInnerButton} to={link} tabIndex="-1">
              <img
                width="34"
                height="25"
                src={`/img/button-arrow-icon.svg`}
                alt=""
              />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

Tooltip.propTypes = {
  position: PropTypes.number.isRequired,
  isVisible: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  mouseIsIn: PropTypes.func.isRequired,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/tooltip/tooltip.js